/* globals lp */
var jQuery = require('jquery');

var ubBanzai = require('ub/control/banzai-features');
var lightboxFactory = require('ub/lp/editor/lightbox-factory');
var labelStyles = require('ub/elements/label-styles').default;

var elementDefaults = {
  name: 'Lightbox Button',
  content: {
    label: 'Lightbox Button'
  }
};

var isSandboxMode = ubBanzai.features.isSandboxEnabled();

var addButtonToPage = function(page, options) {
  var um = page.undoManager;
  um.startGroup();

  var buttonElement = lp.getModule('lp-pom-button').addNewElementToPage(page, options);
  var buttonModel = buttonElement.model;
  var name        = page.generateDefaultElementName('lp-pom-button', elementDefaults.name);

  if (lp.isLightboxLimitReached()) {
    jQuery(window).trigger('hitInternalLightboxLimit');
    window.editor.showLightboxLimitNotice = true;
  } else {
    // Otherwise, create a lightbox and associate the button with it.
    jQuery(window).trigger({
      type        : 'createdInternalLightbox',
      createdUsing : 'widget'
    });

    var lightboxPage = lightboxFactory.createLightbox(window.editor);

    buttonModel.set('action.lightboxId', lightboxPage.getRefId(), um);
    window.editor.addPage(lightboxPage);
  }

  buttonModel.set('name', name, um);
  buttonModel.set('content.label', elementDefaults.content.label, um);
  buttonModel.set('action.type', 'internalLightbox', um);

  var textStyles = buttonModel.safeGet('style.textStyles');
  var labelContent =  buttonModel.safeGet('content.label');

  buttonElement.label.innerHTML = labelStyles.getLabelHtml(textStyles, labelContent);

  um.endGroup();
};

lp.createModule({
  type            : 'lp-pom-lightbox-button',
  getLimit        : function() {
    return isSandboxMode ? 0 : Infinity;
  },
  isAllowedOnPage : function(page) {
    return page.getConfigValue('allowInternalLightboxes');
  },
  version         : '1.0',
  name            : elementDefaults.name,
  usageType       : 'page-widget',
  elementDefaults : elementDefaults
}, {
  createElementClass : function() {},
  addElementToPage   : addButtonToPage
});



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-lightbox-button/lightbox_button_module.js
// module id = 1466
// module chunks = 0